/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMail: {
  name: 'mail';
  data: string;
} = {
  name: 'mail',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm14.333 2H5.667L12 10.75 18.333 6ZM4 7.25V18h16V7.25l-6.8 5.1a2 2 0 0 1-2.4 0L4 7.25Z" fill="currentColor"/></svg>`,
};
